import React from 'react';
import { Card } from 'semantic-ui-react';
import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/servername';
import Webserver from '../../../functions/server';
import View from './view';

class Orderstatus extends React.Component {

  state = {
    masterData: [],
    data: [],
    partcodeOption: [],
    partcode: [],
    status: ['Waiting'],
    customerOrders: false
  }

  componentDidMount() {
    this.getExecutiveId(this.state.status, this.state.customerOrders);
    this.getpartCode();
  }

  getpartCode() {
    let context = this;
    let customerPoints = 0;
    let data = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }
    $.ajax({
      type: 'POST',
      data: { 'branch': branch_id, 'customer': 96 },
      url: Webserver() + 'purchasedetail/getpartcode.php',
      success: function(data) {
        console.log(data);
        console.log('new1');
        try {
          data = JSON.parse(data);
          console.log(data);
          console.log('new2');
          for (var i = 0; i < data.length; i++) { data[i].id = data[i].partno; }
          context.setState({ partcodeOption: data, partcode: data })
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err) {
        alert('Try again!!!!')
      }
    });
  }

  getExecutiveId(status, customerOrders) {
    let context = this;
    if (customerOrders) { customerOrders = 1; }
    else {
      customerOrders = 0;
    }
    let value = '';
    status.map((c) => {
      if (value == '') { value = "'"+c+"'"; }
      else { value = value+",'"+c+"'" }
    })

    let cook = (ReadCookie("vaigai"));
    let executiveId = cook.id;
    let executiveName = cook.name;
    context.setState({
      load: true,
      message: 'Getting Order Status!!!',
    });
    $.ajax({
      type: 'POST',
      data: { 'id': executiveId, 'status': value, 'customerOrders': customerOrders },
      url: Server() + 'order/getallordersbyexecutiveandstatus.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          console.log(data);
          console.log('news');
          context.setState({ data: data, executiveId: executiveId, executiveName: executiveName })
          context.seprateMaterDetails(data);
        } catch (e) {
        }
      },
      error: function(err)
      {
        context.setState({ load: false });
      }
    })
  }

  seprateMaterDetails(data) {
    var arr = [];
    var array = [];
    $.each(data, function(index, value) {
        if($.inArray(value.mid, arr) == -1)
        {
          arr.push(value.mid);
          array.push(value);
        }
    });
    let master = [];
    array.map((c) => {
      let delivered = 0;
      let canceled = 0;
      let pending_for_delivery = 0;
      let prior_order = 0;
      let waiting = 0;
      let approved = 0;
      let deliveredAmount = 0;
      let canceledAmount = 0;
      let pending_for_deliveryAmount = 0;
      let prior_orderAmount = 0;
      let waitingAmount = 0;
      let approvedAmount = 0;
      data.map((d) => {
        let qty = d.qty;
        let totprice = d.totprice;
        totprice = Number(totprice);
        qty = Number(qty);
        if (c.mid == d.mid) {

          if (d.status != 'Waiting' || d.status != 'Prior Order' || d.status != 'Pending For Delivery' || d.status != 'Canceled' || d.status != 'Delivered') {
            if (d.status == 'Approved') {
              approved = approved + 1;
            }
            approvedAmount = approvedAmount + totprice;
          }

          if (d.status != 'Approved' || d.status != 'Prior Order' || d.status != 'Pending For Delivery' || d.status != 'Canceled' || d.status != 'Delivered') {
            if (d.status == 'Waiting') {
              waiting = waiting + 1;
            }
            waitingAmount = waitingAmount + totprice;
          }

          if (d.status != 'Approved' || d.status != 'Waiting' || d.status != 'Pending For Delivery' || d.status != 'Canceled' || d.status != 'Delivered') {
            if (d.status == 'Prior Order') {
              prior_order = prior_order + 1;
            }
            prior_orderAmount = prior_orderAmount + totprice;
          }

          if (d.status != 'Approved' || d.status != 'Waiting' || d.status != 'Prior Order' || d.status != 'Canceled' || d.status != 'Delivered') {
            if (d.status == 'Pending For Delivery') {
              pending_for_delivery = pending_for_delivery + 1;
            }
            pending_for_deliveryAmount = pending_for_deliveryAmount + totprice;
          }

          if (d.status != 'Approved' || d.status != 'Waiting' || d.status != 'Prior Order' || d.status != 'Pending For Delivery' || d.status != 'Delivered') {
            if (d.status == 'Canceled') {
              canceled = canceled + 1;
            }
            canceledAmount = canceledAmount + totprice;
          }

          if (d.status != 'Approved' || d.status != 'Waiting' || d.status != 'Prior Order' || d.status != 'Pending For Delivery' || d.status != 'Canceled') {
            if (d.status == 'Delivered') {
              delivered = delivered + 1;
            }
            deliveredAmount = deliveredAmount + totprice;
          }
        }
      })
      master.push({
        mid: c.mid,
        voucher_no: c.voucher_no,
        approved: approved,
        approved_amount: approvedAmount,
        waiting: waiting,
        waiting_amount: waitingAmount,
        prior_order: prior_order,
        prior_order_amount: prior_orderAmount,
        pending_for_delivery: pending_for_delivery,
        pending_for_delivery_amount: pending_for_deliveryAmount,
        canceled: canceled,
        canceled_amount: canceledAmount,
        delivered: delivered,
        delivered_amount: deliveredAmount,
      })
    })
    for (var i = 0; i < array.length; i++) {
      for (var j = 0; j < master.length; j++) {
        if (array[i].mid == master[j].mid) {
          array[i].approved = master[j].approved;
          array[i].approved_amount = master[j].approved_amount;
          array[i].waiting = master[j].waiting;
          array[i].waiting_amount = master[j].waiting_amount;
          array[i].prior_order = master[j].prior_order;
          array[i].prior_order_amount = master[j].prior_order_amount;
          array[i].pending_for_delivery = master[j].pending_for_delivery;
          array[i].pending_for_delivery_amount = master[j].pending_for_delivery_amount;
          array[i].canceled = master[j].canceled;
          array[i].canceled_amount = master[j].canceled_amount;
          array[i].delivered = master[j].delivered;
          array[i].delivered_amount = master[j].delivered_amount;
        }
      }
    }
    array.sort(function(a, b){
      var keyA = new Date(a.mid),
          keyB = new Date(b.mid);
      if(keyA > keyB) return -1;
      if(keyA < keyB) return 1;
      return 0;
    });
    this.setState({
      masterData: array
    })
  }

  updatemasterData(masterData) { this.setState({ masterData }) }

  updateData(data) { this.setState({ data }) }

  upDateStatus(value) { this.getExecutiveId(value) }

  updateCustomerOrders(value) {
    this.getExecutiveId(this.state.status, value);
    this.setState({ customerOrders: value })
  }

  render() {
    return (
      <div style={{padding: '0.5%'}}>
        <Loading load={this.state.load} message={this.state.message} />
        <div>
          <View data={this.state.data} updateData={this.updateData.bind(this)} placeorderedit={this.props.placeorderedit}
                executiveId={this.state.executiveId} seprateMaterDetails={this.seprateMaterDetails.bind(this)}
                partcodeOption={this.state.partcodeOption} updatemasterData={this.updatemasterData.bind(this)}
                executiveName={this.state.executiveName} masterData={this.state.masterData} upDateStatus={this.upDateStatus.bind(this)}
                updateCustomerOrders={this.updateCustomerOrders.bind(this)} menuPermission={this.props.menuPermission}
                customer={this.props.customer} getExecutiveId={this.getExecutiveId.bind(this)}/>
        </div>
      </div>
    );
  }
}

export default Orderstatus;
